import { render, staticRenderFns } from "./PromotionDetails.vue?vue&type=template&id=10d8189a&scoped=true&"
import script from "./PromotionDetails.vue?vue&type=script&lang=js&"
export * from "./PromotionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDetails.vue?vue&type=style&index=0&id=10d8189a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d8189a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSimpleTable})
